import { GlobalState } from '../../reducers';
import { GPSLocationState } from './reducers';

const gpsLocationSelector = (
  store: GlobalState,
): GPSLocationState => (
  store.apps.manual.gpsLocation
);

export default {
  gpsLocationSelector,
};
